import React, { useMemo, useState } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useGetScheduleDashboardRuns } from "api/report-schedules/service";
import ScheduleExportsCalendar from "views/components/Reports/ScheduleExportsCalendar";

const DashboardScheduleExportsCalendar = ({
  activeColorStyle,
  isLightTheme = true,
  onReportClick,
  enabled = true,
  fillHeight = false,
}) => {
  const { t } = useTranslation();
  const [visibleMonth, setVisibleMonth] = useState(() => moment().startOf("month"));
  const year = visibleMonth.year();
  const month = visibleMonth.month() + 1;

  const { data: scheduleRuns = [], isLoading } = useGetScheduleDashboardRuns(
    { limit: 500, year, month },
    { enabled }
  );

  const colors = useMemo(
    () =>
      isLightTheme
        ? {
            panelBg: "#ffffff",
            fieldBg: "#f6f9fc",
            fieldBorder: "#e9ecef",
            titleColor: "#1d253b",
            bodyColor: "#1d253b",
            mutedColor: "#6c757d",
            rowBorder: "#ececec",
            logTextColor: "#1d253b",
            logInfoBg: "#f1f3f5",
            logDangerBg: "#fff5f7",
          }
        : {
            panelBg: "transparent",
            fieldBg: "rgba(255,255,255,0.04)",
            fieldBorder: "rgba(255,255,255,0.12)",
            titleColor: "rgba(255,255,255,0.95)",
            bodyColor: "rgba(255,255,255,0.9)",
            mutedColor: "rgba(255,255,255,0.55)",
            rowBorder: "rgba(255,255,255,0.1)",
            logTextColor: "rgba(255,255,255,0.92)",
            logInfoBg: "rgba(255,255,255,0.06)",
            logDangerBg: "rgba(253, 93, 147, 0.18)",
          },
    [isLightTheme]
  );

  return (
    <ScheduleExportsCalendar
      fillHeight={fillHeight}
      title={t("dashboard.scheduleExports")}
      titleIcon={<i className="tim-icons icon-cloud-download-93 text-primary mr-2" />}
      visibleMonth={visibleMonth}
      onVisibleMonthChange={setVisibleMonth}
      runs={scheduleRuns}
      isLoading={isLoading}
      timezone="GMT-8"
      colors={colors}
      activeColorStyle={activeColorStyle}
      showMeta
      onReportClick={onReportClick}
    />
  );
};

export default DashboardScheduleExportsCalendar;
